export default "__VITE_ASSET__BfMoMWb9__"